// action - account reducer
export const LOGIN = '@auth/LOGIN';
export const LOGOUT = '@auth/LOGOUT';
export const REGISTER = '@auth/REGISTER';
export const SKIP_INFO_COMPLETE = '@auth/SKIP-INFO-COMPLETE';
export const OPEN_INFO_COMPLETE = '@auth/OPEN-INFO-COMPLETE';
